import { Component, Input } from '@angular/core';
import { DEFAULT_USERNAME } from 'src/app/extensions/constants/commonConstants';
import { PROFILE_CATEGORY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'my-user-profile',
  templateUrl: './my-user-profile.component.html',
  styleUrls: ['./my-user-profile.component.scss'],
  standalone: false,
})
export class MyUserProfileComponent {
  @Input() profileData: app.models.ProfileModel = {
    username: DEFAULT_USERNAME,
    partner: {},
  } as app.models.ProfileModel;
  @Input() partnerAdresses: app.models.AddressProfileModel[];
  @Input() partnerBankAccounts: app.models.BankAccountProfileModel[];
  @Input() requestTypes: app.models.DictionaryRequestType[];
  @Input() readOnly: boolean = true;

  PROFILE_CATEGORY = PROFILE_CATEGORY;
  selectedCategory: string = PROFILE_CATEGORY.GENERAL;

  categoryChangeHandler(selectedCategory: string) {
    this.selectedCategory = selectedCategory;
  }
}
